import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 576 512"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M265.7 407.9c4.5-1.1 9-2.3 13.5-3.4 55.9-14.3 119.4-30.6 185.3-28.7 4.1-31.4 30.9-55.7 63.5-55.7V144c-35.3 0-63.9-28.6-64-63.9-47-1.7-96.8 9.5-153.7 24-4.5 1.1-9 2.3-13.5 3.5-55.9 14.3-119.4 30.6-185.3 28.7-4.1 31.4-31 55.7-63.5 55.7v176c35.3 0 63.9 28.6 64 63.9 47 1.7 96.8-9.5 153.7-24M0 421.5V113c0-24.2 25.4-40.3 48.4-34 79.8 22 159.7 1.6 239.6-18.7 86.9-22.1 173.8-44.3 260.7-12C565.8 54.6 576 72 576 90.5V399c0 24.3-25.4 40.3-48.3 34-79.9-22-159.8-1.6-239.7 18.7-86.9 22.1-173.8 44.3-260.7 12C10.2 457.4 0 440 0 421.5M288 352c-44.2 0-80-43-80-96s35.8-96 80-96 80 43 80 96-35.8 96-80 96" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }